import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = "Legend - Audiovisual Digital Comics",
  description = "Experience comics like never before with Legend's immersive audiovisual platform. Full character voice acting, multi-language support, and exclusive drops from top publishers.",
  keywords = "audiovisual comics, digital comics, manga, webtoons, graphic novels, character audio",
  image = "https://cdn.prod.website-files.com/6357a366954c9c7fad43fdd8/63933d2135f74b3cd45c2a8e_Legend%20Logo%20-%20Gold.png",
  url = "https://visual-story-forge.emergent.host",
  type = "website"
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={url} />
      
      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default SEO;
